
import React, { useEffect, useState } from 'react';
import Select from "../../common/Select.jsx";


const DEFAULT_AUTOCOMPLETE = 'off';
/*
 * Settings - common helper components for rendering setting views
 */
const Setting = {
  TextField: class extends React.Component {
      constructor(props) {
        super(props);
        this.debouncedOnChange = _.debounce(this.onChange, 300);
      }
      render() {
          return (
              <div className="setting">
                  <label>
                      {this.props.label}
                      <input 
                        ref={el => this.inputElement = el} 
                        type="text" 
                        name={this.props.name} 
                        className="form-control" 
                        defaultValue={this.props.value} 
                        placeholder={this.props.placeholder} 
                        onBlur={this.onChange} 
                        onKeyPress={this.props.onKeyPress}
                        data-component-type={this.props.componentType}
                        disabled={this.props.disabled}
                        autoComplete={this.props.autoComplete ?? DEFAULT_AUTOCOMPLETE}
                      />
                  </label>
                  {this.props.description ? (<p className="description">{this.props.description}</p>) : null}
              </div>
          );
      }
      onChange = (e) => {
          this.props.onChange(e);
      }
      componentDidMount() {
          jQuery(this.inputElement).on('change keyup', this.debouncedOnChange);
      }
      componentWillUnmount() {
          jQuery(this.inputElement).off('change keyup', this.debouncedOnChange);
      }
  },
  LongTextField: class extends React.Component {
      constructor(props) {
        super(props);
        this.debouncedOnChange = _.debounce(this.onChange, 300);
      }
      
      render() {
          return (
              <div className="setting">
                  <label>
                      {this.props.label}
                      <textarea
                        ref="textarea"
                        name={this.props.name}
                        className="form-control"
                        defaultValue={this.props.value}
                        onKeyUp={this.debouncedOnChange}
                        onBlur={this.onChange}
                        disabled={this.props.disabled}
                        autoComplete={this.props.autoComplete ?? DEFAULT_AUTOCOMPLETE}
                      />
                  </label>
                  {this.props.description ? (<p className="description">{this.props.description}</p>) : null}
              </div>
          );
      }

      onChange = (e) => {
        this.props.onChange(e);
      }

      componentDidMount() {
          // Scale textarea height to content height.
          jQuery(this.refs.textarea).on('input propertychange', (e) => {
              jQuery(e.currentTarget).css('height', 'auto');
              jQuery(e.currentTarget).outerHeight(e.currentTarget.scrollHeight + 10);
          }).trigger('input');
      }
  },
  Dropdown: class extends React.Component {
      render() {
          let options = (this.props.options || []).map((o) => {
              let opt = Array.isArray(o) ? o : [o, o];
              return (<option key={opt[0]} value={opt[0]}>{opt[1]}</option>);
          });
          return (
              <div className="setting" style={{...(this.props.style || {})}}>
                  <label>
                      {this.props.label}
                      {this.props.disabled ? <input type="hidden" name={this.props.name} defaultValue={this.props.value} /> : null}
                      <select name={this.props.name} className="form-control" defaultValue={this.props.value} onChange={this.props.onChange} disabled={this.props.disabled} autoComplete={this.props.autoComplete ?? DEFAULT_AUTOCOMPLETE}>
                          {this.props.includeBlankOption && <option value="">{I18n.t('select')}...</option>}
                          {options}
                      </select>
                  </label>
                  {this.props.description ? (<p className="description">{this.props.description}</p>) : null}
              </div>
          );
      }
  },
  Checkbox: class extends React.Component {
      render() {
          return (
              <div className={"setting checkbox " + (this.props.className || "")} style={{...(this.props.style || {})}}>
                  <label>
                      <input type="hidden" name={this.props.name} defaultValue={this.props.disabled ? this.props.value : "false"}/>
                      <input type="checkbox" name={this.props.name} defaultChecked={this.props.value} defaultValue="true" onChange={this.props.onChange} disabled={this.props.disabled} />
                      {this.props.label}
                  </label>
                  {this.props.description ? (<p className="description">{this.props.description}</p>) : null}
              </div>
          );
      }
  },
  RadioSelection: class extends React.Component {
      render() {
          return (              
              <div className="setting">
              <label>{this.props.label}</label>
                  <div className="checkbox-list">

                      {this.props.options.map((option) => {
                          return(
                              <label key={option.key}>
                                  <input 
                                      type="radio" 
                                      name={this.props.name} 
                                      value={option.key} 
                                      onChange={this.props.onChange}
                                      checked={this.props.selectedOption === option.key}
                                  />
                                  {option.label}
                              </label>
                          )
                      })}
                  </div>
              </div>
          )
      }
  },
  MultiSelect: class extends React.Component {

      render() {
          return (              
              <div className="setting">
              <label>{this.props.label}</label>
                  <div className="checkbox-list">
                      <Select className="multi-select-dropdown"                         
                              value={this.props.value}
                              onChange={this.props.onChange}
                              options={this.props.options} 
                              autoComplete={this.props.autoComplete ?? DEFAULT_AUTOCOMPLETE}
                              isMulti > 
                      </Select>
                  </div>
                  {this.props.description ? (<p className="description">{this.props.description}</p>) : null}
              </div>
          )
      }
  },
  ColorPicker: class extends React.Component {

      componentDidMount(){
          jQuery(".colorpicker-component").not(".colorpicker-element").colorpicker();
          jQuery(".colorpicker-component .color-picker-input")
          .off("blur")
          .on("blur", this.props.onChange);
      }

      render(){
          return (
              <div className="setting">
                  <label>
                      {this.props.label}
                      <div className="input-group colorpicker-component">
                          <input 
                              type="text" 
                              className="form-control color-picker-input" 
                              name={this.props.name}
                              onChange={this.props.onChange}
                              autoComplete={this.props.autoComplete ?? DEFAULT_AUTOCOMPLETE}
                              defaultValue={this.props.value} />
                          <span className="input-group-addon">
                              <i style={{ backgroundColor: this.props.value }}></i>
                          </span>
                      </div>
                  </label>
              </div>
          )
      }
  },
/* 
 * N.B! This setting can only rendered when component content contains endpoint.
 */
ExternalEntityLinker: (props) => {
  const [options, setOptions] = useState(false);
  const [loading, setLoading] = useState(true);
  
  const { endpoint, externalEntityLinkingCallback, parent } = props;
  
  useEffect(() => {
    let isMounted = true;

    if (endpoint && typeof props.externalEntityLinkingCallback === 'function') {
      const fetchData = async () => {

        const response = await props.externalEntityLinkingCallback(endpoint, {parent: parent});
        if (isMounted) {
          setOptions(response);
          setLoading(false);
        }
      }
      fetchData();
    } else {
      console.warn("ExternalEntityLinker didn't receive callback or endpoint")
    }
    return () => (isMounted = false)
  }, [endpoint, externalEntityLinkingCallback, parent])


  let opts = (options || []).map((o) => {
    let opt = Array.isArray(o) ? o : [o, o];
      return (<option key={opt[0]} value={opt[0]}>{opt[1]}</option>);
  });
  return (
      <div className="setting">
          <label>
              {props.label}

              {props.disabled ? <input type="hidden" name={props.name} defaultValue={props.value} /> : null}
              {loading ? I18n.t('loading') :
                <select name={props.name} className="form-control" defaultValue={props.value} onChange={props.onChange} disabled={props.disabled} autoComplete={props.autoComplete ?? DEFAULT_AUTOCOMPLETE}>
                  {opts}
                </select>
              }
          </label>
          {props.description ? (<p className="description">{props.description}</p>) : null}
      </div>
  );

}
}


export default Setting;